export default {
  ar() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'تطبيق الخصم',
      cartEmpty: 'سلة المشتريات الخاصة بك فارغة',
      continueShopping: 'الاستمرار فى التسوق',
      currency: 'العملة',
      eventTransportation: 'Event Transportation',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'الدفع',
      processingFee: 'رسوم المعالجة',
      processingFeeTax: 'ضرائب/رسوم المعالجة',
      promoCode: 'Promo Code',
      reviewYourOrder: 'مراجعة طلبك',
      tax: 'ضرائب',
      vatTax: 'ضريبة القيمة المضافة',
      yourItems: 'عناصرك',
      yourTotal: 'مجموعك',
    }
  },

  de() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'Ermäßigung anwenden',
      cartEmpty: 'Ihr Warenkorb ist leer',
      continueShopping: 'Weiter einkaufen',
      currency: 'Währung',
      eventTransportation: 'Event-Transport',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'Zahlungen',
      processingFee: 'Bearbeitungsgebühr',
      processingFeeTax: 'Bearbeitungsgebühr',
      promoCode: 'Promo-Code',
      reviewYourOrder: 'Ihre Bestellung überprüfen',
      tax: 'Steuer',
      vatTax: 'MwSt.',
      yourItems: 'Ihre Artikel',
      yourTotal: 'Ihr Gesamtbetrag',
    }
  },

  en() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'Apply',
      cartEmpty: 'Your cart is empty.',
      cartEmptyGpe: 'Your basket is currently empty',
      continueShopping: 'Continue Shopping',
      currency: 'Currency',
      eventTransportation: 'Event Transportation',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'Payment',
      processingFee: 'Processing Fee',
      processingFeeTax: 'Processing Fee/Tax',
      promoCode: 'Promo Code',
      reviewYourOrder: 'Review Your Order',
      tax: 'Tax',
      vatTax: 'VAT Tax',
      yourItems: 'Your Items',
      yourTotal: 'Your Total',
    }
  },

  enGB() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'Apply',
      cartEmpty: 'Your basket is empty.',
      cartEmptyGpe: 'Your basket is currently empty',
      continueShopping: 'Continue Shopping',
      currency: 'Currency',
      eventTransportation: 'Event Transportation',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'Payment',
      processingFee: 'Processing Fee',
      processingFeeTax: 'Processing Fee/Tax',
      promoCode: 'Promo Code',
      reviewYourOrder: 'Review Your Order',
      tax: 'Tax',
      vatTax: 'VAT Tax',
      yourItems: 'Your Items',
      yourTotal: 'Your Total',
    }
  },

  esMX() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'Aplicar Descuento',
      cartEmpty: 'Su carrito está vacío',
      continueShopping: 'Continuar Comprando',
      currency: 'Moneda',
      eventTransportation: 'Transporte al Evento',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'Pago',
      processingFee: 'Tarifa de Procesamiento',
      processingFeeTax: 'Cuota de Procesamiento / impuesto',
      promoCode: 'Código Promocional',
      reviewYourOrder: 'revise su orden',
      tax: 'Impuestos',
      vatTax: 'VAT Tax',
      yourItems: 'Tus cosas',
      yourTotal: 'Su Total',
    }
  },

  fr() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'Appliquer une réduction',
      cartEmpty: 'Votre panier est vide',
      continueShopping: 'Continuer vos achats',
      currency: 'Devise',
      eventTransportation: 'Transport pour l\'événement',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'Paiement',
      processingFee: 'Frais de traitement',
      processingFeeTax: 'Frais de traitement/taxe',
      promoCode: 'Code Promo',
      reviewYourOrder: 'vérifier votre commande',
      tax: 'Taxe',
      vatTax: 'Taxe VAT',
      yourItems: 'Vos objets',
      yourTotal: 'Votre total',
    }
  },

  it() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'Utilizza un codice sconto',
      cartEmpty: 'Il tuo carrello è vuoto.',
      continueShopping: 'Continua a fare acquisti',
      currency: 'Valuta',
      eventTransportation: 'Trasporto agli eventi',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'Pagamento',
      processingFee: 'Spese di commissione',
      processingFeeTax: 'Imposte',
      promoCode: 'Codice promozionale',
      reviewYourOrder: 'controlla il tuo ordine',
      tax: 'Imposte',
      vatTax: 'IVA',
      yourItems: 'I tuoi articoli',
      yourTotal: 'Il tuo totale',
    }
  },

  ja() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: '割引を適用する',
      cartEmpty: 'ショッピングカートには何も入っていません。',
      continueShopping: 'ショッピングを続ける',
      currency: '通貨',
      eventTransportation: 'イベント交通',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'お支払いについて',
      processingFee: '手数料',
      processingFeeTax: '取引手数料／税',
      promoCode: 'Promo Code',
      reviewYourOrder: '注文内容を確認する',
      tax: '税',
      vatTax: '付加価値税',
      yourItems: 'あなたのアイテム',
      yourTotal: '合計金額',
    }
  },

  pl() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: 'zastosuj rabat',
      cartEmpty: 'Twój koszyk jest pusty.',
      continueShopping: 'kontynuuj zakupy',
      currency: 'waluta',
      eventTransportation: 'transfer na wydarzenie',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: 'płatność',
      processingFee: 'opłata manipulacyjna',
      processingFeeTax: 'opłata manipulacyjna/podatek',
      promoCode: 'kod promocyjny',
      reviewYourOrder: 'sprawdź swoje zamówienie',
      tax: 'podatek',
      vatTax: 'podatek VAT',
      yourItems: 'Twoje przedmioty',
      yourTotal: 'suma ogółem',
    }
  },

  zhCN() {
    return {
      addHotel: 'Add a hotel to your package',
      applyDiscount: '使用折扣',
      cartEmpty: '您的购物车是空的。',
      continueShopping: '继续购物',
      currency: '货币',
      eventTransportation: '活动交通',
      mustAddHotel: 'You must add a hotel before you can purchase this package',
      paymentCount: '支付',
      processingFee: '处理费',
      processingFeeTax: '手续费/税',
      promoCode: '促销码',
      reviewYourOrder: '查看您的订单',
      tax: '税费',
      vatTax: '增值税',
      yourItems: '您的物品',
      yourTotal: '总额',
    }
  }
}
